import { ContentService } from 'src/ConsentManagement/ContentService';
import { getText } from 'src/ConsentManagement/TranslationService';
import { Publish } from 'src/Shared/EventPublisher/EventEmitter';
import { ConsentEventType } from 'src/Shared/EventPublisher/ConsentEventType';
import { JSXInternal } from 'preact/src/jsx';
import { Container } from '../shared/Container';
import { Description } from '../shared/Description';
import { Heading } from '../shared/Heading';
import { Grid } from '../shared/Grid';
import { Icon } from '../shared/Icon';
import { VendorsList } from './VendorsList';
import { ScrollableContent } from '../shared/ScrollableContent';
import { PrivacyFooter } from '../shared/PrivacyFooter';
import { Button } from '../shared/Button';
import { ActionButtons } from '../shared/Buttons/ActionButtons';

const VendorsKey = () => (
  <p>
    <Grid direction={'horizontal'} collapse={true}>
      <Icon variant={'other-vendors'} />
      <span>{getText('other_vendors')}</span>
    </Grid>
  </p>
);

export const VendorsPanel = () => {
  return (
    <Container sectionId={'vendors_layer'}>
      <div class="ccm-row clearfix">
        <Button
          class="vendors-back-button"
          translationKey="back"
          fullWidth={false}
          icon={<Icon variant="chevron"></Icon>}
          onClick={() => Publish(ConsentEventType.REQUEST_SHOW_PREFERENCES_LAYER)}
        />
      </div>
      <ScrollableContent>
        <Heading />
        <Description textTranslationKey={'vendors_message'} />
        <VendorsKey />
        <VendorsList />
      </ScrollableContent>
      <PrivacyFooter>
        <ActionButtons rejectId="ccmgt_vendors_reject" acceptId="ccmgt_vendors_accept" />
      </PrivacyFooter>
    </Container>
  );
};

export const RenderVendorsPanel = async (): Promise<() => JSXInternal.Element> => {
  await ContentService.FetchActiveLanguage();
  return VendorsPanel;
};
